import { message } from "antd";
import useRequest from "./useRequest";
import { useState } from "react";
import { createStaticHandler } from "react-router";

const useExcursions = () => {
  const [excursions, setExcursions] = useState([]);
  const [excursionDetail, setExcursionDetail] = useState();
  const [excursionTypes, setExcursionTypes] = useState([]);
  const [loading, setLoading] = useState({
    get: false,
    post: false,
    put: false,
    delete: false,
  });

  const { request } = useRequest();

  async function createScheduledExcursion(body) {
    setLoading((prev) => ({ ...prev, post: true }));
    const data = await request(
      "POST",
      "scheduled-excursions/",
      (data) => {
        setLoading((prev) => ({ ...prev, post: false }));
        message.success("Excursión creada correctamente");
        return data;
      },
      (error) => {
        setLoading((prev) => ({ ...prev, post: false }));
        message.error("Error al crear la excursión");
        return error;
      },
      body
    );
    return data;
  }

  async function editScheduledExcursion(body) {
    setLoading((prev) => ({ ...prev, put: true }));
    const data = await request(
      "PATCH",
      `scheduled-excursions/${body.id}/`,
      (data) => {
        setLoading((prev) => ({ ...prev, put: false }));
        message.success("Excursión actualizada correctamente");
        return data;
      },
      (error) => {
        setLoading((prev) => ({ ...prev, put: false }));
        message.error("Error al actualizar la excursión");
        return error;
      },
      body
    );
    return data;
  }

  async function getActiveExcursionTypes(params = {}) {
    return await request(
      "GET",
      "excursion-prices/available/",
      (data) => {
        return data;
      },
      (error) => {
        return error;
      },
      {},
      params
    );
  }

  async function getExcursions(params = {}) {
    return await request(
      "GET",
      "scheduled-excursions/",
      (data) => {
        setExcursions(data);
        return data;
      },
      (error) => {
        return error;
      },
      {},
      params
    );
  }

  async function getExcursionDetail(id, params = {}) {
    return await request(
      "GET",
      `scheduled-excursions/${id}/`,
      (data) => {
        setExcursionDetail(data);
        return data;
      },
      (error) => {
        return error;
      },
      {},
      params
    );
  }

  async function createExcursion(body) {
    setLoading((prev) => ({ ...prev, post: true }));
    const data = await request(
      "POST",
      "excursions/",
      (data) => {
        setLoading((prev) => ({ ...prev, post: false }));
        return data;
      },
      (error) => {
        setLoading((prev) => ({ ...prev, post: false }));
        return error;
      },
      body
    );
    return data;
  }

  async function updateBusPayment(body) {
    setLoading((prev) => ({ ...prev, put: true }));
    const data = await request(
      "PATCH",
      `scheduled-excursions-buses/expenses/${body.id}/`,
      (data) => {
        setLoading((prev) => ({ ...prev, put: false }));
        message.success("Gasto actualizado correctamente");
        return data;
      },
      (error) => {
        setLoading((prev) => ({ ...prev, put: false }));
        message.error("Error al actualizar el gasto");
        return error;
      },
      body
    );
    return data;
  }

  async function createBusPayment(body) {
    setLoading((prev) => ({ ...prev, post: true }));
    const data = await request(
      "POST",
      "scheduled-excursions-buses/expenses/",
      (data) => {
        setLoading((prev) => ({ ...prev, post: false }));
        message.success("Gasto creado correctamente");
        return data;
      },
      (error) => {
        setLoading((prev) => ({ ...prev, post: false }));
        message.error("Error al crear el gasto");
        return error;
      },
      body
    );
    return data;
  }

  async function deleteBusPayment(paymentId) {
    setLoading((prev) => ({ ...prev, delete: true }));
    const data = await request(
      "DELETE",
      `scheduled-excursions-buses/expenses/${paymentId}/`,
      (data) => {
        setLoading((prev) => ({ ...prev, delete: false }));
        message.success("Gasto eliminado correctamente");
        return data;
      },
      (error) => {
        message.error("Error al eliminar el gasto");
        setLoading((prev) => ({ ...prev, delete: false }));
        return error;
      }
    );
    return data;
  }

  return {
    getExcursions,
    getExcursionDetail,
    excursions,
    setExcursions,
    createExcursion,
    createScheduledExcursion,
    getActiveExcursionTypes,
    editScheduledExcursion,
    createBusPayment,
    updateBusPayment,
    deleteBusPayment,
    loading,
    excursionDetail,
  };
};

export default useExcursions;
